import { Link } from "@mui/material";
import dayjs from "dayjs";
import { EditableDataGrid } from "../../../builderPackage/components/editableDataGrid/editableDataGrid";
import { showSurface } from "../../../redux/awaitedSurfacesSlice";
import { useAppDispatch } from "../../../store/hooks";
import { ViewServiceHistory } from "./viewSeviceHistory";
export var JobCardDetailsCatalogView = function (props) {
    var dispatch = useAppDispatch();
    var value = props.value, error = props.error, _a = props.name, name = _a === void 0 ? 'ServiceDetails' : _a;
    var currValue = value[name];
    var pagingColumns = [{
            field: 'DealerName',
            headerName: 'Dealer name',
            minWidth: 175
        }, {
            field: 'BranchName',
            headerName: 'Branch',
            minWidth: 175
        }, {
            field: 'JobCard',
            headerName: 'Job card no',
            minWidth: 175
        }, {
            field: 'DocDate',
            headerName: 'Job card date',
            valueFormatter: function (val, row) {
                if (row !== null && row !== void 0 && row.DocDate) {
                    var DocDate = row !== null && row !== void 0 && row.DocDate ? dayjs.utc(row.DocDate).format('DD MMM, YYYY') : '-';
                    return DocDate;
                }
                else {
                    return '-';
                }
            },
            minWidth: 175
        }, {
            field: 'Model',
            headerName: 'Product',
            valueFormatter: function (val, row) { return row !== null && row !== void 0 && row.Model ? "".concat(row === null || row === void 0 ? void 0 : row.Model) : '-'; },
            minWidth: 200
        }, {
            field: 'CustomerName',
            headerName: 'Customer name',
            valueFormatter: function (val, row) { return row !== null && row !== void 0 && row.CustomerName ? "".concat(row === null || row === void 0 ? void 0 : row.CustomerName) : '-'; },
            minWidth: 200
        }, {
            field: 'Mobile',
            headerName: 'Customer no.',
            valueFormatter: function (val, row) { return row !== null && row !== void 0 && row.Mobile ? "".concat(row === null || row === void 0 ? void 0 : row.Mobile) : '-'; },
            minWidth: 200
        }, {
            field: 'ServiceAdvisorName',
            headerName: 'Service advisor',
            valueFormatter: function (val, row) { return row !== null && row !== void 0 && row.ServiceAdvisorName ? "".concat(row === null || row === void 0 ? void 0 : row.ServiceAdvisorName) : '-'; },
            minWidth: 150
        }, {
            field: 'MechanicName',
            headerName: 'Technician',
            valueFormatter: function (val, row) { return row !== null && row !== void 0 && row.MechanicName ? "".concat(row === null || row === void 0 ? void 0 : row.MechanicName) : '-'; },
            minWidth: 150
        }, {
            field: 'JobType',
            headerName: 'Service type',
            valueFormatter: function (val, row) { return row !== null && row !== void 0 && row.JobType ? "".concat(row === null || row === void 0 ? void 0 : row.JobType) : '-'; },
            minWidth: 150
        }, {
            field: 'CustomerVoice',
            headerName: 'Customer voice',
            valueFormatter: function (val, row) { return row !== null && row !== void 0 && row.CustomerVoice ? "".concat(row === null || row === void 0 ? void 0 : row.CustomerVoice) : '-'; },
            minWidth: 150
        }, {
            field: 'UsageReading',
            headerName: 'Odometer reading',
            valueFormatter: function (val, row) { return row !== null && row !== void 0 && row.UsageReading ? "".concat(row === null || row === void 0 ? void 0 : row.UsageReading) : '-'; },
            minWidth: 150
        }, {
            field: 'Invoices',
            headerName: 'Invoice number',
            valueFormatter: function (val, row) { return row !== null && row !== void 0 && row.Invoices ? "".concat(row === null || row === void 0 ? void 0 : row.Invoices) : '-'; },
            minWidth: 150
        }, {
            field: 'actions',
            headerName: 'Actions',
            width: 150,
            headerAlign: 'left',
            disableColumnMenu: true,
            renderCell: function (params) {
                return /*#__PURE__*/ React.createElement(Link, {
                    underline: "none",
                    component: 'button',
                    sx: {
                        fontSize: 'base',
                        fontWeight: 'medium'
                    },
                    onClick: function () {
                        dispatch(showSurface({
                            type: 'Drawer',
                            Component: ViewServiceHistory,
                            containerProps: {
                                PaperProps: {
                                    sx: {
                                        width: '60%'
                                    }
                                },
                                anchor: 'right'
                            },
                            componentProps: {
                                data: params === null || params === void 0 ? void 0 : params.row,
                                isFromQuickLink: value === null || value === void 0 ? void 0 : value.isFromQuickLink
                            }
                        }));
                    }
                }, "View");
            }
        }];
    return /*#__PURE__*/ React.createElement(EditableDataGrid, {
        dataGridHeader: "Job Cards",
        isCollapsible: true,
        columns: pagingColumns,
        disableAddRow: true,
        disableDeleteRow: true,
        dataGridProps: {
            checkboxSelection: false,
            disableRowSelectionOnClick: true,
            hideFooter: true,
            initialState: {
                pinnedColumns: {
                    right: ['actions']
                }
            }
        }
        // rows={crud[vehicleHistoryKeys.SeviceHistoryKey]?.data?.ServiceDetails || []}
        ,
        rows: currValue || [],
        error: error === null || error === void 0 ? void 0 : error[name]
    });
};
